module.exports = __webpack_public_path__ + "static/media/channel=subaccount.39a012af.svg";